var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "material-icons-32p"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2071_44464",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2071_44464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "price_check",
    d: "M8.88955 19.9443V18.4999H5.33398V16.2777H12.4451V13.0554H6.46732C6.16361 13.0554 5.8988 12.9462 5.67288 12.7277C5.44695 12.5092 5.33398 12.2406 5.33398 11.9221V6.4999C5.33398 6.18139 5.44324 5.91658 5.66175 5.70547C5.88028 5.49436 6.1414 5.3888 6.44508 5.3888H8.88955V3.94434H11.1118V5.3888H14.6673V7.611H7.55618V10.8332H13.534C13.8525 10.8332 14.121 10.9388 14.3396 11.1499C14.5581 11.361 14.6673 11.6332 14.6673 11.9666V17.3888C14.6673 17.6925 14.5618 17.9536 14.3507 18.1721C14.1395 18.3906 13.8747 18.4999 13.5562 18.4999H11.1118V19.9443H8.88955ZM18.6007 27.9443L12.934 22.2777L14.4895 20.7221L18.6007 24.8333L26.4451 16.9888L28.0007 18.5443L18.6007 27.9443Z",
    fill: "#054BC7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceCheck);
export default __webpack_public_path__ + "static/media/price_check.e130fdd9a1d40bc85ab99f3c6bb75bd9.svg";
export { ForwardRef as ReactComponent };